import cImg1 from '../images/blog/news-1.jpeg'
import cImg2 from '../images/blog/news-2.jpg'
import cImg3 from '../images/blog/news-3.avif'
import cImg4 from '../images/casestudy/threat-img4.jpg'
import cImg5 from '../images/casestudy/threat-img5.jpg'
import cImg6 from '../images/casestudy/theret-img1.jpg'




const caseStudies = [
    { id: 1, category: "cat1", img: cImg1, title: "European Airport Disruptions Caused by Ransomware Attack", slug: "https://www.securityweek.com/european-airport-disruptions-caused-by-ransomware-attack/" },
    { id: 2, category: "cat1", img: cImg2, title: "Jaguar Land Rover Admits Data Breach Caused by Recent Cyberattack", slug: "https://www.securityweek.com/jaguar-land-rover-admits-data-breach-caused-by-recent-cyberattack/" },
    { id: 3, category: "cat1", img: cImg3, title: "Drones and cyber outages exposing aviation weak spots since 2017", slug: "https://www.reuters.com/business/aerospace-defense/drones-cyber-outages-exposing-aviation-weak-spots-since-2017-2025-09-23/" },
    // { id: 4, category: "cat1", img: cImg4, title: "Design system & UI kit..", slug: "Design" },
    // { id: 5, category: "cat1", img: cImg5, title: "Offline SEO marketing..", slug: "Development" },
    // { id: 6, category: "cat1", img: cImg6, title: "IT security enhancement..", slug: "Support" },
   ];
export default caseStudies;